import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 安全读取本地存储：Safari 隐私模式、禁用网站数据或存储内容损坏时，
// 直接访问 localStorage / JSON.parse 会抛错，会导致整个 store 模块加载失败、页面白屏
function safeGet(storage, key, fallback) {
  try {
    let raw = storage.getItem(key);
    if (!raw || raw === 'undefined' || raw === 'null') return fallback;
    let val = JSON.parse(raw);
    return val === null || val === undefined ? fallback : val;
  } catch (e) {
    try { storage.removeItem(key); } catch (err) {}
    return fallback;
  }
}

let userInfo = safeGet(localStorage, 'userInfo', {});
let appInfo = safeGet(localStorage, 'appInfo', {});

let token = '';
let messageNum = 0;
try {
  token = sessionStorage.getItem('token') || localStorage.getItem('token') || '';
  messageNum = token ? localStorage.getItem('messageNum') || 0 : 0;
} catch (e) {
  token = '';
  messageNum = 0;
}

export default new Vuex.Store({
  //state存放状态,
  state: {
    userInfo,
    token,
    messageNum,
    appInfo,
    bannerList: [],
    realbetList: [],
    jokerList: [],
    gamingList: [],
    sportList: [],
    lotteryList: [],
    conciseList: [],
  },
  //getter为state的计算属性
  getters: {

  },
  //mutations可更改状态的逻辑，同步操作
  mutations: {
    changGameList(state) {
      state.bannerList = safeGet(localStorage, 'bannerList', []);
      state.realbetList = safeGet(localStorage, 'realbetList', []);
      state.jokerList = safeGet(localStorage, 'jokerList', []);
      state.gamingList = safeGet(localStorage, 'gamingList', []);
      state.sportList = safeGet(localStorage, 'sportList', []);
      state.lotteryList = safeGet(localStorage, 'lotteryList', []);
      state.conciseList = safeGet(localStorage, 'conciseList', []);
    },
    changUserInfo(state) {
      state.userInfo = safeGet(localStorage, 'userInfo', {});
    },
    changToken(state) {
      try {
        state.token = sessionStorage.getItem('token') || localStorage.getItem('token') || '';
      } catch (e) {
        state.token = '';
      }
    }
    , changMessageNum(state) {
      try {
        let show = localStorage.getItem('show');
        state.messageNum = show ? 0 : localStorage.getItem('messageNum');
      } catch (e) {
        state.messageNum = 0;
      }
    }
    , changappInfo(state) {
      state.appInfo = safeGet(localStorage, 'appInfo', {});
    },
  },
  //提交mutation，异步操作
  actions: {

  },
  // 将store模块化
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js